import type { FC, ReactNode } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import type { ITheme } from '@homeviews/styles'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      border: '0.5px solid rgba(0,0,0,0.02)',
      borderRadius: theme.spacing(0.625),
      boxShadow: '0 15px 20px 0 rgba(46,81,123,0.04)',
      backgroundColor: theme.colors.white,
      padding: theme.spacing(2.5, 2.75),
    },
    header: {
      marginBottom: theme.spacing(2),
    },
  }),
)

interface IProps {
  children?: ReactNode
  className?: string
  onClick?: () => void
  header?: ReactNode
  eventName?: string
}

const Card: FC<IProps> = ({
  children,
  className,
  onClick = null,
  header,
  eventName,
}) => {
  const classes = useStyles()

  return (
    <div
      onClick={onClick && onClick}
      className={clsx('c-card', classes.root, className)}
      data-event-name={eventName || ''}
    >
      {!!header && <div className={classes.header}>{header}</div>}
      {children}
    </div>
  )
}

export default Card
